import { yup } from '@framework/validation/initYup.ts';
import { createUniqueAliasesTest } from './schemaValidationUtils.ts';

export const MapLayerIntersectionSchema = yup
  .object({
    enabled: yup.boolean().default(false).label('Intersezione abilitata'),
    title: yup
      .string()
      .default('Intersezioni')
      .label('Titolo Intersezioni')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.required() : schema.strip(),
      ),
    attributes: yup
      .array(yup.string().required())
      .default([])
      .label('Attributi')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.min(1).required() : schema.strip(),
      ),
    aliases: yup
      .object()
      .default({})
      .label('Alias attributi')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.test(createUniqueAliasesTest()) : schema.strip(),
      ),
    areaTolerance: yup
      .number()
      .default(0.05)
      .label('Tolleranza (metri quadri minimi)')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.required() : schema.strip(),
      ),
    cadastralPreset: yup.boolean().default(false).label('Preset catastale'),
    backofficeOnly: yup
      .boolean()
      .default(false)
      .label('Visibile solo in Back Office'),
    maxResults: yup
      .number()
      .integer()
      .min(1)
      .default(100)
      .label('Numero massimo risultati')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.required() : schema.strip(),
      ),
  })
  .addChildrenParentDeps();
